import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Box,
  CircularProgress,
  IconButton,
  Link,
  Typography,
} from '@mui/material';
import { CloudDownload, FileUpload } from '@mui/icons-material';

import TranslationsContext from '../../Container/Language/TranslationsContext';
import StateContext from '../../HO/State/StateContext';
import QueueContext from '../Layout/QueueProgress/QueueContext';

const ExportQueueButton = (props) => {
  const { t } = useContext(TranslationsContext);
  const stateContext = useContext(StateContext);
  const { addQueue, queues } = useContext(QueueContext);

  const { sendRequest } = stateContext;

  const { exportQueueRoute, form } = props;
  const queue = _.find(queues, (q) => (q.type === exportQueueRoute));

  const [loading, setLoading] = useState(false);
  const [jobId, setJobId] = useState(null);

  const iconButtonProps = {
    title: t('app:common:export'),
    onClick: () => {
      setLoading(true);

      sendRequest(exportQueueRoute, {
        body: form,
      }).then((response) => {
        if (response.success && response.data) {
          setJobId(response.data);

          addQueue(response.data, {
            type: exportQueueRoute,
            title: t('app:common:export'),
          });
        }
        setLoading(false);
      });
    },
    disabled: loading,
  };

  useEffect(() => {
    if (jobId) {
      setJobId(null);
    }
  }, [form]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading || (queue && !queue.finished)) {
    if (queue && queue.percent > 0) {
      const progressWrapperState = {
        sx: {
          position: 'relative',
          display: 'inline-flex',
        },
      };
      const boxProps = {
        sx: {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      };
      const typographyProps = {
        variant: 'caption',
        component: 'div',
        color: 'text.secondary',
      };

      return (
        <Box {...progressWrapperState}>
          <CircularProgress variant="determinate" value={queue.percent} sx={{ m: 1 }} />
          <Box {...boxProps}>
            <Typography {...typographyProps}>
              {Math.round(queue.percent)}
              %
            </Typography>
          </Box>
        </Box>
      );
    }

    return (<CircularProgress sx={{ m: 1 }} />);
  }

  if (jobId && !loading) {
    return queue && queue.result?.report ? (
      <Link
        href={queue.result.report}
        target="_blank"
        sx={{ m: 1 }}
      >
        <CloudDownload sx={{ fontSize: 32 }} />
      </Link>
    ) : null;
  }

  return (
    <IconButton {...iconButtonProps}>
      <FileUpload />
    </IconButton>
  );
};

ExportQueueButton.propTypes = {
  exportQueueRoute: PropTypes.string.isRequired,
  form: PropTypes.instanceOf(Object).isRequired,
};

ExportQueueButton.defaultProps = {

};

export default ExportQueueButton;
